// ./src/pages/private/EventSchedulePage/recurrenceDefaults.ts
//
// The repeat rule a recurring event starts with before the host sets one: weekly, on the start's weekday, from the
// start's time to the end's (else the event's own length). ONE copy, shared by the Schedule page and the create wizard's
// Schedule step (ROADMAP A2b #62) — two copies would offer a different "default" depending on where the host looked.
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// ⚠ TYPE-ONLY: the API client module reads Vite's env at load, and `check-event-setup` runs this file under Node.
import type { RecurrenceRule } from '@/utils/api/EventService';

dayjs.extend(utc);
dayjs.extend(timezone);

/** `RECURRENCE_FREQ.WEEKLY` — a literal for the reason above; `check-event-setup` pins that the two agree. */
const WEEKLY: RecurrenceRule['freq'] = 'weekly';

export const defaultRecurrenceRule = (startsAt: string | null | undefined, tz: string, endsAt?: string | null): RecurrenceRule => {
  const start = startsAt ? dayjs.utc(startsAt).tz(tz) : null;
  const end = endsAt ? dayjs.utc(endsAt).tz(tz) : null;
  // ⚠ The END the host typed on Basics, when it is later the same day (19:00–22:00 is three hours, not one — review,
  //   2026-09-30). Otherwise none: the server then gives every date the event's own length.
  const endTime = start && end && end.isAfter(start) && end.isSame(start, 'day') ? end.format('HH:mm') : null;

  return {
    freq: WEEKLY,
    interval: 1,
    byWeekday: start ? [start.day()] : [],
    startTime: start ? start.format('HH:mm') : null,
    endTime,
    until: null,
    count: null,
    rsvpEnabled: true,
  };
};
